module.exports = __webpack_public_path__ + "img/Mask Group1.04817db1.png";